import { Swiper } from 'swiper';
import { A11y, Navigation, Pagination } from 'swiper/modules';

const sliders = document.querySelectorAll(
	'.block-timeline__slider-wrapper .swiper-main'
);

if (sliders.length > 0) {
	sliders.forEach((slider, index) => {
		// Find the closest parent <section> element
		const sectionParent = slider.closest('.block-tab-timeline__container');
		if (sectionParent) {
			sectionParent.classList.add(`block-tab-timeline__swiper--${index}`);
		}

		const settings = {
			grabCursor: false,
			spaceBetween: 0,
			slidesPerView: 1,
			clickable: false,
			slideToClickedSlide: false,
			loop: true,
			effect: 'fade',
			modules: [A11y, Navigation, Pagination],
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			navigation: {
				prevEl: `.block-tab-timeline__swiper--${index} .swiper-button-prev`,
				nextEl: `.block-tab-timeline__swiper--${index} .swiper-button-next`,
			},
			pagination: {
				el: `.block-tab-timeline__swiper--${index} .image-timeline-swiper`,
				clickable: true,
				bulletClass: 'image-timeline-swiper-bullet',
				renderBullet(indexBullet, className) {
					// Find the associated slide for this bullet
					const slides = slider.querySelectorAll('.swiper-slide');
					let label = indexBullet + 1;
					if (slides && slides[indexBullet]) {
						const dataLabel =
							slides[indexBullet].getAttribute('data-year');
						if (dataLabel) {
							label = dataLabel;
						}
					}
					return (
						'<span class="' + className + '">' + label + '</span>'
					);
				},
			},
		};

		new Swiper(slider, settings);
	});
}
